<h2>{{ menu?.title }}</h2>
<mat-divider></mat-divider>
<app-menu [menu]="menu?.childs" (submenuClick)="onSubmenuClick($event)"> </app-menu>
